import { defineFcm } from '../shared/factory';

export const FCM_USE_DONATION_LANGUAGE = defineFcm('use_donation_language').asBoolean().withDefault(false).toConfig();
